import React, {Component} from 'react'
import {AppPageWrapper} from "./NavMenu/AppPageWrapper";
import {Container, Spinner} from "react-bootstrap";

export interface LoadingProps{
    message: string
    showNav?: boolean
    delayedVisibility?: boolean
    embedingMode?: boolean
}
export default class PageLoading extends Component<LoadingProps>{
    render() {
        return (<AppPageWrapper showNav={this.props.showNav} embedingMode={!!this.props.embedingMode}>
            <Container fluid={true} className={"m-2"}>
                <div className={`text-center ${this.props.delayedVisibility ? "delayedVisibility" : ""}`}>
                    <Spinner animation="border" />
                    <br />
                    {this.props.message}
                </div>
            </Container>
        </AppPageWrapper>);
    }
}
